import { db } from "~/db/db";
import dateTimeBR from "~services/utils/formatDateHourBR";
import { getOrganizedDates } from "./initializerHelpers";
import { deepCopy } from "~services/utils/deepCopy";
import { getLocalStorage, saveLocalStorage } from "~services/utils/SaveIndexBD";

export const toFormatSearchs = ({searchs, pesquisaObjetos}) => {
  let toReturn = [];

  if (searchs.length) {
    searchs.map(e => {
      const pesquisaEmbalagem = pesquisaObjetos.pesquisaEmbalagens?.pesquisaEmbalagemObjeto['id-' + e.pesquisaEmbalagemId];
      const pesquisaGrupoMaterial = pesquisaObjetos.pesquisaGrupoMateriais?.pesquisaGrupoMaterialObjeto['id-' + e.pesquisaGrupoMaterialId];

      toReturn.push({
        id: e.id,
        ativo: e.ativo,
        clienteId: e.clienteId,
        dadosGerais: {
          grupoProduto: pesquisaGrupoMaterial ?? "",
          grupoProdutoId: e.pesquisaGrupoMaterialId ?? "",
          player: pesquisaObjetos?.pesquisaPlayers?.pesquisaPlayerObjeto['id-' + e.pesquisaPlayerId] ?? "",
          playerId: e.pesquisaPlayerId ?? "",
          produto: pesquisaObjetos?.pesquisaProdutos?.pesquisaProdutoObjeto['id-' + e.pesquisaProdutoId] ?? "",
          produtoId: e.pesquisaProdutoId ?? "",
          embalagemCapacidade: pesquisaEmbalagem ?? "",
          embalagemCapacidadeId: e.pesquisaEmbalagemId ?? "",
          embalagem: getMedida(pesquisaEmbalagem?.nome),
          frete: e.frete ?? "",
          canal: pesquisaObjetos?.pesquisaCanaisDistribuicao?.pesquisaCanalDistribuicaoObjeto['id-' + e.pesquisaCanalDistribuicaoId] ?? "",
          canalId: e.pesquisaCanalDistribuicaoId ?? "",
          pesquisaCentroOrigemId: e.pesquisaCentroOrigemId ?? "",
          pesquisaCentroOrigem: pesquisaObjetos?.pesquisaCentros?.pesquisaCentroOrigemObjeto['id-' + e.pesquisaCentroOrigemId] ?? "",
          incoterms: e.incoterms ?? ""
        },
        infosAdicionais: {
          volume: e.volume === undefined ? null : e.volume,
          medida: pesquisaObjetos?.pesquisaMedidas?.pesquisaMedidaObjeto['id-' + e.pesquisaUnidadeMedidaId] ?? "",
          medidaId: e.pesquisaUnidadeMedidaId ?? "",
          prazo: pesquisaObjetos?.pesquisaPrazos?.pesquisaPrazoObjeto['id-' + e.pesquisaPrazoId] ?? "",
          prazoId: e.pesquisaPrazoId,
          sellIn: e.sellIn ?? 0,
          sellOut: e.sellOut ?? 0,
          precoCIF: e.precoCIF ?? 0,
          precoFOB: e.precoFOB ?? 0,
          frete: e.frete ?? 0,
          nomeContato: e.contato ?? "",
          localPesquisa: e.local ?? "",
          localPesquisaId: e.localId ?? "",
          contextoPesquisa: e.contexto ?? "",
          contextoPesquisaId: e.contextoId ?? "",
        },
        updatedAt: dateTimeBR(e.updatedAt),
        updatedAtEN: e.updatedAt,
        createdAt: dateTimeBR(e.createdAt),
        createdAtEN: e.createdAt,
        deletadoEm: e.deletadoEm ? dateTimeBR(e.deletadoEm) : null,
        ultimaAtualizacao: e.ultimaAtualizacao ? dateTimeBR(e.ultimaAtualizacao) : null,
        ultimaAtualizacaoEN: e.ultimaAtualizacao
      })
    })
  }

  return toReturn;
}

export const getMedida = (medida) => {
  if(!medida){//ERRADO, PORÉM, EVITA ERRO.
    return {
      value: 1,
      unidade: 'GRANEL'
    }
  }

  const str = medida;
  const regex = /(\d+)([A-Za-z]+)/;
  const match = str?.match(regex);

  if (match) {
    const number = isNaN(match[1]) ? 1 : parseInt(match[1]);
    return {
      value: number,
      unidade: match[2]
    }
  } else if (medida.toLowerCase() == "granel") {
    return {
      value: 1,
      unidade: 'GRANEL'
    }
  } else {
    return {
      value: 1,
      unidade: medida
    };
  }
}

function pad(number, length) {
  let str = '' + number;
  while (str.length < length) {
      str = '0' + str;
  }
  return str;
}

export const formatDateToCustomString = (date) => {
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1, 2);
  const day = pad(date.getDate(), 2);
  const hours = pad(date.getHours(), 2);
  const minutes = pad(date.getMinutes(), 2);
  const seconds = pad(date.getSeconds(), 2);

  const fractionalSeconds = pad(Math.floor(date.getMilliseconds() * 1000), 7);

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${fractionalSeconds}`;
}

export const roundAndAdjust = (values) => {
  let roundedValues = values.map(Math.round);
  let total = roundedValues.reduce((acc, val) => acc + val, 0);
  let difference = total - 100;

  if (difference !== 0) {
      let maxIndex = roundedValues.indexOf(Math.max(...roundedValues));
      roundedValues[maxIndex] -= difference;
  }

  return roundedValues;
}

export const checkTodaySearchs = async ({clienteId, pesquisaId, obj = {}}) => {
  try {
    const data = [];
    await db.mapaDaMina.where('clienteId').equals(clienteId).each((e) => data.push(e));

    const filteredData = data.filter(e => !e.deletadoEm);
    const { dates, lastDate } = getOrganizedDates({data: filteredData});

    const curDate = new Date();
    const curDateKey = `${curDate.getFullYear()}-${(curDate.getMonth() + 1).toString().padStart(2, '0')}-${curDate.getDate().toString().padStart(2, '0')}`;
    const formatedDate = formatDateToCustomString(curDate);

    let newData = [];

    if(curDateKey != lastDate && dates[lastDate]?.length > 0){
      newData = processDateItems(dates[lastDate], pesquisaId, obj, formatedDate);
    }

    if(newData?.length > 0){
      await db.mapaDaMina.bulkPut(newData);
    }

    return {
      newData,
      created: newData?.length > 0,
      id: 0
    };
  } catch (error) {
    throw error instanceof Error ? error : new Error(String(error));
  }
}

const processDateItems = (items, pesquisaId, obj, formatedDate) => {
  const newData = [];
  const randomId = () => Math.floor(Math.random() * 10**15).toString().padStart(15, '0');

  items.filter(e => e.ativo).forEach(e => {
    newData.push(createInactiveItem(e, randomId));
    const repeatItem = createRepeatItem(e, pesquisaId, obj, formatedDate);
    newData.push(repeatItem);
  });

  return newData;
}

const createInactiveItem = (item, randomId) => {
  return {
    ...deepCopy(item),
    ativo: false,
    originalId: item.id,
    wasDuplicated: true,
    id: randomId()
  };
}

const createRepeatItem = (item, pesquisaId, obj, formatedDate) => {
  const repeatItem = {
    ...deepCopy(item),
    pesquisaPaiId: item.pesquisaPaiId ?? item.id ?? null,
    notSave: true,
    createdAt: formatedDate,
    updatedAt: formatedDate
  };

  if(Object.keys(obj).length > 0 && pesquisaId && pesquisaId == repeatItem.originalId && repeatItem.ativo){
    Object.keys(obj).forEach(key => {
      repeatItem[key] = obj[key];
    })
  }

  return repeatItem;
}

const checkStorageExistence = async () => {
  let obj = getLocalStorage('cliente-pesquisas-mm', true);
  if(!obj) {
    saveLocalStorage('cliente-pesquisas-mm', {}, true);
  }
}

export const setSendedSearch = async ({ clienteId, date, data = {} }) => {
  await checkStorageExistence();

  if(date instanceof Date && !isNaN(clienteId)) {
    const obj = getLocalStorage('cliente-pesquisas-mm', true);
    const key = `${clienteId} - ${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;

    if(!obj[key]) obj[key] = {};

    obj[key].dados = data;

    saveLocalStorage('cliente-pesquisas-mm', obj, true);
  }
}

export const getSendedSearch = async ({clienteId, date}) => {
  await checkStorageExistence();

  if(date instanceof Date && !isNaN(clienteId)){
    const obj = getLocalStorage('cliente-pesquisas-mm', true);
    const key = `${clienteId} - ${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;

    return obj[key];
  }

  return false;
}

export const updateNaoIds = async ({ historyIds = [], clienteId }) => {
  if (historyIds?.length > 0) {
    const dataHistory = historyIds.map(e => ({
      id: e,
      clienteId
    }));
    if (dataHistory?.length > 0)
      await db.mapaDaMinaNaoIds.bulkPut(dataHistory);

    return dataHistory;
  }

  return [];
}

export const updateData = async ({data, resetMapaDaMina = false, clienteId}) => {
  const historyIds = {};
  await db.mapaDaMinaNaoIds.filter(e => e.clienteId == clienteId).each(e => historyIds[`id-${e.id}`] = true);

  const searchs = [];

  for (const e of data) {
    if(!historyIds[`id-${e.id}`]){
      searchs.push({
        ...e,
        originalId: e.id,
        pesquisaPaiId: e.pesquisaPaiId ?? e.id ?? null
      });
    }
  }

  if(resetMapaDaMina) await resetMapa({data: searchs, table: db.mapaDaMina, clienteId});

  await resetMapa({data: searchs, table: db.mapaDaMinaOriginal, clienteId});

  return {success: true};
}

export const resetMapa = async ({data, table = db.mapaDaMina, clienteId}) => {
    try {
      const ids = []
      await table.filter(e => e.clienteId == clienteId).each(e => ids.push(e.id));

      // Operação em uma transação
      await db.transaction('rw', table, async () => {
        await table.bulkDelete(ids);
        await table.bulkPut(data);
      });

      return {success: true};

    } catch (error) {
      return {success: false};
    }
  };


  export const getPosOrCheckinData = ({pos, checkin}) => {
    Object.keys(pos).forEach(key => {
      pos[key] = pos[key] ? pos[key].toString() : null;
    });

    return {
      latitude: pos.latitude?.trim() ? pos.latitude : checkin?.latitude?.toString() ?? "",
      longitude: pos.longitude?.trim() ? pos.longitude : checkin?.longitude?.toString() ?? "",
      precisaoMetros: pos.precisaoMetros?.trim() ? pos.precisaoMetros : checkin?.precisao?.toString() ?? "",
    };
  }